const {
  i18n: { __ },
  components: { Button },
} = wp;

export const MediaRemoveButton = ({ className, ...rest }) => {
  return (
    <Button className={`media-button remove-button ${className}`} {...rest}>
      {__('Remove', 'b3rg')}
    </Button>
  );
};

export const MediaReplaceButton = ({ className, ...rest }) => {
  return (
    <Button
      className={`media-button remove-button replace-button ${className}`}
      {...rest}
    >
      {__('Replace', 'b3rg')}
    </Button>
  );
};
